import React from "react";
import { Component } from "react";
import { Button } from 'react-bootstrap';
import '../styles/Filters.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faSave } from "@fortawesome/free-solid-svg-icons";

class Config extends Component<any>  {

    constructor(props: any) {
        super(props);
    }

    navOnAddWidget = () => {
        const { onAddWidget } = this.props;
        if (onAddWidget) {
            onAddWidget();
        }
    }  
    
    navOnSaveDashboard = () => {
        const { onSaveDashboard } = this.props;
        if (onSaveDashboard) {
          onSaveDashboard();
        }
    }
    renderSaveButton() {
        const { isPublic } = this.props;
        if (isPublic) {
          return '';
        }
        return <Button className="float-right m-2" variant="secondary" key="save" onClick={this.navOnSaveDashboard}>Save <FontAwesomeIcon icon={faSave} /></Button>;
      }
    
    renderAddWidgetButton() {
        const { isPublic } = this.props;
        if (isPublic) {
            return '';
        }
        return <Button className="float-left m-2" variant="secondary" onClick={this.navOnAddWidget}><FontAwesomeIcon icon={faPlus} /> Add Widget</Button>;
    }

    render() {
        return (
            <div className="widget">
                <div className="widgetContents">
                {this.props.showDashboardOptions &&
                    this.renderAddWidgetButton()
                }
                {this.props.showDashboardOptions &&
                    this.renderSaveButton()
                }
                </div>
            </div>                  
        );
    }
}

export default Config;